import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ecaa4e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sn_navlist" }
const _hoisted_2 = { class: "sn-tabs-container" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "sn-tabs-item-wrap"
}
const _hoisted_5 = ["onClick"]

import { TMenuType } from '@/module/database';

type TProps = {
    menuData: Array<TMenuType>
    subItem?: Array<TMenuType>
    tabIndex: number | string
    subIndex: number | string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    menuData: null,
    subItem: null,
    tabIndex: { default: '' },
    subIndex: { default: '' }
  },
  emits: ['onTabsSwitch', 'onSubSwitch'],
  setup(__props: any, { emit }) {

const props = __props as { menuData: Array<TMenuType>, subItem?: Array<TMenuType>, tabIndex: number | string, subIndex: number | string }





//点击一级导航
const onTabsSwitch = (Id: number, index: number) => {
    emit('onTabsSwitch', Id, index)
}
//点击子导航
const onSubSwitch = (Id: number, index: number) => {
    emit('onSubSwitch', Id, index)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.menuData, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(['sn-tabs_tab', { 'sn-tabs_active': index === __props.tabIndex }]),
          key: item.Id,
          onClick: ($event: any) => (onTabsSwitch(item.Id,index))
        }, [
          _createElementVNode("span", null, _toDisplayString(item.Name), 1)
        ], 10, _hoisted_3))
      }), 128))
    ]),
    (__props.subItem&&__props.subItem.length>0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.subItem, (sub, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(['sn-tabs-wrap_item',{'sn-subitem_active':index===__props.subIndex}]),
              key: sub.Id,
              onClick: ($event: any) => (onSubSwitch(sub.Id,index))
            }, [
              _createElementVNode("span", null, _toDisplayString(sub.Name), 1)
            ], 10, _hoisted_5))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})